import { render, staticRenderFns } from "./FormBuilderSection.vue?vue&type=template&id=1e0816de&scoped=true"
import script from "./FormBuilderSection.vue?vue&type=script&lang=js"
export * from "./FormBuilderSection.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderSection.vue?vue&type=style&index=0&id=1e0816de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0816de",
  null
  
)

export default component.exports